import { IEventAggregationService, ISubscriber } from '@studyportals/event-aggregation-service-interface';
import { EventAggregationService } from './platform/EventAggregationService';
import { IAppRegistration, SearchPageAppActivatedEvent } from '@studyportals/search-page-interface';
import { SearchPageNavigationPerformedEvent } from './routing/events/SearchPageNavigationPerformedEvent';

export class ActivatedApp implements ISubscriber<SearchPageNavigationPerformedEvent> {
	private readonly eventAggregationService: IEventAggregationService;

	private _application: IAppRegistration | null = null;

	public constructor(eventAggregationService?: IEventAggregationService) {
		this.eventAggregationService = eventAggregationService ?? EventAggregationService.instance;
		this.eventAggregationService.subscribeTo(SearchPageNavigationPerformedEvent.EventType, this, true);
	}

	public get application(): IAppRegistration | null {
		return this._application;
	}

	public notify(event: SearchPageNavigationPerformedEvent): void | Promise<void> {
		if (SearchPageNavigationPerformedEvent.is(event)) {
			this.onNavigationPerformed(event);
		}
	}

	private onNavigationPerformed(event: SearchPageNavigationPerformedEvent): void {
		const applicationBefore = this._application;
		const application = event.targetApp;

		this._application = application;

		if (applicationBefore !== application && application !== null) {
			this.notifyForAppActivated(application);
		}
	}

	private notifyForAppActivated(application: IAppRegistration): void {
		this.eventAggregationService.publishTo(SearchPageAppActivatedEvent.EventType, new SearchPageAppActivatedEvent(application.type));
	}
}
